module.exports = __webpack_public_path__ + "47ebaaa827891b4ffdd49240f8c750fe.svg";